import { useContext } from "react";
import { EnvironmentContext } from "../contexts/EnvironmentContext";

const useEnvironment = () => {
    const environmentContext = useContext(EnvironmentContext);

    return {environment: environmentContext};
}

export default useEnvironment;